module.exports = __webpack_public_path__ + "img/one.af01674b.gif";